/**
     * @desc 查询作品集列表，包含自己创建的collection（必须有已铸造的NFT），和购买的NFT所属的collection
查询作品集列表，包含自己创建的collection（必须有已铸造的NFT），和购买的NFT所属的collection
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/collection/getCollectionListWithReference', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/collection/getCollectionListWithReference', params);
}
